<template>
  <div>
    <div class="sticky-top">
      <div class="content-wrapper">
        <nav class="page-navigation">
          <div class="header-container">
            <a role="navigation" tabindex="0" accesskey="h" class="home-link"
              :href="homeLink"
              ><img
                src="/assets/images/eLearning-logo.svg"
                alt="NSPCC Learning Home"
                class="img-fluid"                
            /></a>
            <span class="header-title d-flex align-items-center"
              >Self-Assessment Tool</span
            >
            <div>
              <div  v-if="signedin" class="signout-group">
               <div class="welcome"> <a role="navigation" class="welcome-link d-none d-lg-block" @click="routeToOverview()" @keydown.enter="routeToOverview()">Welcome {{ getFirstName }}</a></div>
                <div class="signout">
                  <a role="navigation" href="#" class="signout-link" @click="logout" @keydown.enter="logout">Sign out</a>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <breadcrumbs class="d-none d-lg-block"></breadcrumbs>
    <div class="content-wrapper">
      <router-view :key="$route.fullPath"></router-view>
      <!-- <router-view :key="$route.fullPath"></router-view> -->
      <!-- possible fix for routing to same route/component with query params -->
    </div>
    <FooterBar />
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import FooterBar from "./components/footer-bar";

export default {
  name: "App",
  components: { FooterBar },
  computed: {
    ...mapGetters("account", ["getFirstName"]), 
    signedin:{
      get(){ return this.$store.state.account.status.signedin;}
    },
    homeLink: {
      get() {
        return window.location.origin;
      }
    },
    unsavedChanges: {
      get() {
        return this.$store.state.unsavedChanges
      },
      set(val) {
        this.$store.commit('setUnsavedChanges', val)
      }
    },     
  },
  mounted() {
    /* Need to to authorisation at router level */
    //this.authenticateUserAction();
    
  },
  methods: {
    ...mapActions("alert", ["clear"]),
    ...mapActions("account", ["signout", "authenticateUserAction"]),

    ...mapState("users", ["user"]),
    logout() {
      if(this.unsavedChanges) {
        const answer = window.confirm(
         "You have not saved changes. If you don’t save them before leaving, you will lose them.\n\nAre you sure you want to leave?"
        );
        if (answer) {
          this.unsavedChanges = false;
          this.signout();
          window.location.href = window.location.origin + "/self-assessment-tools-login/#/";
        } else {
          return;
        }
      } else {
        this.signout();
        window.location.href = window.location.origin + "/self-assessment-tools-login/#/";
      }
          
    },
      routeToOverview() {
        if(this.unsavedChanges) {
          const answer = window.confirm(
            "You have not saved changes. If you don’t save them before leaving, you will lose them.\n\nAre you sure you want to leave?"
          );
          if (answer) {
            this.unsavedChanges = false;
            window.location.href =
            window.location.origin + "/self-assessment-tools/#/?activeTab=3";
          } else {
            return;
          }
        } else {
          window.location.href =
          window.location.origin + "/self-assessment-tools/#/?activeTab=3";
        }
    }
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        // clear alert on location change
        this.clear();
      }
    }
    
  }
  //created : function() {
  // this.$nextTick(function() {
  //     /**
  //      * Code that will run only after the entire view has been rendered
  //      * On: focus blur => Floating label
  //      * Based on http://jsfiddle.net/RyanWalters/z9ymd852/
  //      */
  //     $(".floating-label input, .floating-label textarea")
  //       .on("focus blur", function(e) {
  //         $(this)
  //           .parents(".floating-label")
  //           .toggleClass(
  //             "focused",
  //             e.type === "focus" || this.value.length > 0
  //           );
  //       })
  //       .trigger("blur");
  //   }.bind(this));
  //}
};
//import '@fortawesome/fontawesome-free/js/all.js';
</script>

<style lang="scss">
@import "@/assets/sass/index.scss";
</style>
